module.exports = __webpack_public_path__ + "7284bd20cd66c2622a3adc20c20aae7f.jpg";